<template>
  <loading padding="8" v-if="loading" />
  <div v-else-if="surveys">
    <div class="py-2">
      <wd-filter
        :filters="filters"
        :input-array="surveys"
        @update="filteredSurveys = $event"
      />
    </div>
    <survey
      class="odd:bg-gray-200"
      v-for="survey in filteredSurveys"
      :key="survey.id"
      :survey="survey"
    />
    <load-more-section name="survey" @input="getSurveys" />
    <fab @input="openManage">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const Survey = require("@/modules/surveys/components/Survey.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const LoadMoreSection = require("@/modules/core/components/LoadMoreSection.vue")
  .default;
const WdFilter = require("@/modules/core/components/WdFilter.vue").default;

export default {
  name: "SurveySite",
  data() {
    return {
      surveys: null,
      filteredSurveys: [],
      filters: [],
    };
  },
  props: {},
  components: {
    Survey,
    Fab,
    LoadMoreSection,
    WdFilter,
  },
  methods: {
    openManage() {
      this.goTo("/survey-manage");
    },
    async getSurveys() {
      this.surveys = await this.getEntity("survey");
    },
  },
  computed: {},
  async created() {
    await this.getSurveys();

    this.filters.push(
      {
        name: this.$t("surveys.question"),
        key: "question",
        input: "text",
      },
      {
        name: this.$t("surveys.type.type"),
        key: "type",
        input: "select",
        type: "equal",
        options: [
          {
            name: this.$t("surveys.type.single"),
            type: "single",
          },
          {
            name: this.$t("surveys.type.multiple"),
            type: "multi",
          },
        ],
        optionLabel: "name",
        optionId: "type",
      },
      {
        name: this.$t("surveys.status.status"),
        key: "status",
        input: "select",
        type: "equal",
        options: [
          {
            name: this.$t("surveys.status.pending"),
            status: "pending",
          },
          {
            name: this.$t("surveys.status.done"),
            status: "done",
          },
        ],
        optionLabel: "name",
        optionId: "status",
      }
    );

    this.loaded();
  },
};
</script>